var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-container"},[_c('div',{staticClass:"canvas-container",class:_vm.platform,style:(_vm.canvasStyle)},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }